var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-button"}},[_c('button',{attrs:{"type":"button","onclick":"location.href='https://eestec.ro'"}},[_c('p',{staticClass:"fs-large-1 "},[_vm._v(_vm._s(_vm.$t("contact.contactButton.text")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }